export { default as ResetPasswordForm } from './ResetPasswordForm.container';
